export default function throttle (callback, time) {
    var lastCalled = null;

    return function () {
        const now = new Date().getTime();
        if (lastCalled === null || lastCalled + time < now) {
            lastCalled = now;
            callback.apply(this, arguments);
        }
    }
}
